<template>
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10 col-12">
        <!-- CONNECTION ALERT (Shows only if disconnected) -->
        <div v-if="!isConnected" class="alert alert-danger text-white border-0 py-2 mb-3">
           <i class="fas fa-exclamation-triangle me-2"></i> 
           Disconnected from Chat Server. Attempting to reconnect...
        </div>

        <div class="card shadow-lg border-0 chat-card">
          <!-- CHAT HEADER -->
          <div class="card-header bg-gradient-primary p-3 d-flex justify-content-between align-items-center">
            <h6 class="text-white mb-0"><i class="fas fa-comments me-2"></i> Live Global Chat</h6>
            <div class="d-flex align-items-center">
              <span class="badge" :class="isConnected ? 'bg-success' : 'bg-danger'">
                {{ isConnected ? 'Online' : 'Offline' }}
              </span>
              <span class="text-white text-xs font-weight-bold ms-2">{{ userName }}</span>
            </div>
          </div>

          <!-- CHAT BODY -->
          <div class="card-body chat-body" ref="chatWindow">
            <div v-for="msg in history" :key="msg.id" :class="['chat-group', msg.author === userName ? 'sent' : 'received']">
              <span v-if="msg.author !== userName" class="author-label text-xxs ms-2">{{ msg.author }}</span>
              <div class="chat-bubble">
                <p class="mb-1 message-text">{{ msg.formatted_content }}</p>
                <div class="d-flex justify-content-between align-items-center mt-1">
                  <span class="text-xxs opacity-7">{{ formatDate(msg.createdAt) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- INPUT -->
          <div class="card-footer p-3 bg-light">
            <div class="input-group">
              <input type="text" v-model="inputText" class="form-control" placeholder="Type a message..." @keyup.enter="submitInfo" />
              <button @click="submitInfo" class="btn btn-primary mb-0" :disabled="!inputText || !isConnected">
                <i class="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { io } from "socket.io-client";
import axios from "axios";

export default {
  data() {
    return {
      socket: null,
      isConnected: false,
      inputText: "",
      history: [],
      // UPDATED: apiBaseUrl fetched from .env file as per your reference in Devices.vue
      apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
      userName: localStorage.getItem('userName') || 'User_' + Math.floor(Math.random() * 999)
    };
  },
  methods: {
    submitInfo() {
      if (!this.inputText.trim()) return;

      console.log("Sending message via socket:", this.inputText);
      
      this.socket.emit('live_webhook_input', {
        text: this.inputText,
        userName: this.userName
      });

      this.inputText = "";
    },
    async fetchHistory() {
      try {
        const token = localStorage.getItem('token');
        // UPDATED: Using dynamic apiBaseUrl from .env to match the route defined in app.js
        const response = await axios.get(`${this.apiBaseUrl}/v1/admin/webhook/history`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        this.history = response.data.reverse();
        this.scrollToBottom();
      } catch (e) { console.error("History failed:", e); }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chat = this.$refs.chatWindow;
        if (chat) chat.scrollTop = chat.scrollHeight;
      });
    },
    formatDate(date) {
      return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
  },
  mounted() {
    this.fetchHistory();

    // NEW: Get the JWT token from localStorage
    const token = localStorage.getItem('token');

    // UPDATED: FETCH SOCKET URL FROM .env FILE
    const socketUrl = process.env.VUE_APP_SOCKET_URL || "http://localhost:3005";

    // UPDATED: FORCE CONNECTION TO PRODUCTION/LOCAL URL WITH JWT AUTHENTICATION
    this.socket = io(socketUrl, {
      auth: {
        token: token // This passes the token to the io.use middleware in app.js
      },
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log("✅ Socket Connected & Authorized!");
      this.isConnected = true;
    });

    // NEW: Handle Authentication Errors
    this.socket.on('connect_error', (err) => {
      console.error("❌ Socket Auth Error:", err.message);
      this.isConnected = false;
    });

    this.socket.on('disconnect', () => {
      console.log("❌ Socket Disconnected!");
      this.isConnected = false;
    });

    this.socket.on('live_webhook_display', (data) => {
      console.log("📩 Message Received:", data);
      this.history.push({
        id: data.id,
        original_content: data.original,
        formatted_content: data.text,
        author: data.user,
        createdAt: new Date()
      });
      this.scrollToBottom();
    });
  }
};
</script>

<style scoped>
.chat-card { height: 75vh; }
.chat-body { flex-grow: 1; overflow-y: auto; padding: 20px; background: #f8f9fa; }
.chat-group { display: flex; flex-direction: column; margin-bottom: 10px; max-width: 80%; }
.chat-group.sent { margin-left: auto; align-items: flex-end; }
.chat-group.received { margin-right: auto; align-items: flex-start; }
.chat-bubble { padding: 8px 12px; border-radius: 12px; }
.sent .chat-bubble { background: #5e72e4; color: white; }
.received .chat-bubble { background: white; color: #32325d; border: 1px solid #dee2e6; }
</style>